(function(){
  var root = document.getElementById('MemKeuzehulp');
  if (!root) return;

  var state = { type: null, vorm: '', materiaal: '' };
  var currentStep = 1;

  var panels = root.querySelectorAll('[data-step-panel]');
  var dots = root.querySelectorAll('.mem-keuzehulp__step-dot');

  function showStep(step){
    currentStep = step;
    panels.forEach(function(panel){
      panel.hidden = Number(panel.dataset.stepPanel) !== step;
    });
    dots.forEach(function(dot){
      var n = Number(dot.dataset.step);
      dot.classList.toggle('is-active', n === step);
      dot.classList.toggle('is-done', n < step);
    });
  }

  root.querySelectorAll('[data-question]').forEach(function(group){
    var key = group.dataset.question;
    var autoAdvance = group.dataset.autoAdvance;
    var options = group.querySelectorAll('.mem-keuzehulp__option');
    options.forEach(function(btn){
      btn.addEventListener('click', function(){
        options.forEach(function(b){ b.classList.remove('is-selected'); });
        btn.classList.add('is-selected');
        state[key] = btn.dataset.value;

        if (key === 'type' && btn.dataset.value === 'maatwerk') {
          setTimeout(showMaatwerk, 220);
          return;
        }

        if (key === 'type' && btn.dataset.value === 'anders') {
          setTimeout(showAnders, 220);
          return;
        }

        if (autoAdvance === 'next') {
          setTimeout(function(){ showStep(currentStep + 1); }, 220);
        } else if (autoAdvance === 'results') {
          setTimeout(function(){ showStep(4); loadResults(); }, 220);
        }
      });
    });
  });

  root.querySelectorAll('[data-back]').forEach(function(btn){
    btn.addEventListener('click', function(){ showStep(currentStep - 1); });
  });

  var grid = document.getElementById('MemKeuzehulpGrid');
  var loading = document.getElementById('MemKeuzehulpLoading');
  var note = document.getElementById('MemKeuzehulpResultsNote');
  var heading = document.getElementById('MemKeuzehulpResultsHeading');
  var moreLink = document.getElementById('MemKeuzehulpMoreLink');
  var maatwerkBlock = document.getElementById('MemKeuzehulpMaatwerk');

  var andersBlock = document.getElementById('MemKeuzehulpAnders');

  var restartBtn = root.querySelector('[data-restart]');
  if (restartBtn) {
    restartBtn.addEventListener('click', function(){
      state = { type: null, vorm: '', materiaal: '' };
      root.querySelectorAll('.mem-keuzehulp__option').forEach(function(b){ b.classList.remove('is-selected'); });
      maatwerkBlock.hidden = true;
      andersBlock.hidden = true;
      showStep(1);
    });
  }

  var resultsBackBtn = root.querySelector('[data-results-back]');
  if (resultsBackBtn) {
    resultsBackBtn.addEventListener('click', function(){
      showStep((state.type === 'maatwerk' || state.type === 'anders') ? 1 : 3);
    });
  }

  function showMaatwerk(){
    showStep(4);
    heading.textContent = 'Een maatwerk urn, speciaal voor u';
    loading.hidden = true;
    note.hidden = true;
    moreLink.hidden = true;
    grid.innerHTML = '';
    andersBlock.hidden = true;
    maatwerkBlock.hidden = false;
  }

  function showAnders(){
    state.type = 'anders';
    showStep(4);
    heading.textContent = 'Afscheidsbloemen & accessoires';
    loading.hidden = true;
    note.hidden = true;
    moreLink.hidden = true;
    grid.innerHTML = '';
    maatwerkBlock.hidden = true;
    andersBlock.hidden = false;
  }

  if (andersBlock && andersBlock.dataset.forceOpen === 'true') {
    root.querySelectorAll('.mem-keuzehulp__option[data-value="anders"]').forEach(function(b){ b.classList.add('is-selected'); });
    showAnders();
  }

  var cache = {};
  function fetchCollection(handle){
    if (!handle) return Promise.resolve([]);
    if (cache[handle]) return cache[handle];
    cache[handle] = fetch('/collections/' + handle + '/products.json?limit=250')
      .then(function(r){ return r.json(); })
      .then(function(data){ return data.products || []; })
      .catch(function(){ return []; });
    return cache[handle];
  }

  function intersect(lists){
    if (lists.length === 0) return [];
    if (lists.length === 1) return lists[0];
    var idSets = lists.slice(1).map(function(list){ return new Set(list.map(function(p){ return p.id; })); });
    return lists[0].filter(function(p){ return idSets.every(function(s){ return s.has(p.id); }); });
  }

  function imageUrl(product){
    var src = product.images && product.images[0] ? product.images[0].src : '';
    if (!src) return '';
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=400';
  }

  function renderProducts(products){
    grid.innerHTML = '';
    products.slice(0, 9).forEach(function(product){
      var price = product.variants && product.variants[0] ? product.variants[0].price : null;
      var img = imageUrl(product);
      var a = document.createElement('a');
      a.className = 'mem-keuzehulp__product';
      a.href = '/products/' + product.handle;
      a.innerHTML =
        (img ? '<img src="' + img + '" loading="lazy" alt="">' : '<div style="aspect-ratio:1;background:#f4f0ee;"></div>') +
        '<span class="mem-keuzehulp__product-info">' +
          '<span class="mem-keuzehulp__product-title"></span>' +
          (price ? '<span class="mem-keuzehulp__product-price">€ ' + Number(price).toFixed(2).replace('.', ',') + '</span>' : '') +
        '</span>';
      a.querySelector('.mem-keuzehulp__product-title').textContent = product.title;
      grid.appendChild(a);
    });
  }

  function loadResults(){
    maatwerkBlock.hidden = true;
    loading.hidden = false;
    grid.innerHTML = '';
    note.hidden = true;
    moreLink.hidden = true;

    var handles = [state.type, state.vorm, state.materiaal].filter(Boolean);

    Promise.all(handles.map(fetchCollection)).then(function(lists){
      var byHandle = {};
      handles.forEach(function(h, i){ byHandle[h] = lists[i]; });

      var attempts = [
        handles,
        [state.type, state.vorm].filter(Boolean),
        [state.type, state.materiaal].filter(Boolean),
        [state.type].filter(Boolean)
      ];

      var result = [];
      var relaxedIndex = 0;
      for (var i = 0; i < attempts.length; i++) {
        var combo = attempts[i];
        if (combo.length === 0) continue;
        var comboLists = combo.map(function(h){ return byHandle[h]; });
        result = intersect(comboLists);
        if (result.length > 0) {
          relaxedIndex = i;
          break;
        }
      }

      loading.hidden = true;

      if (relaxedIndex > 0) {
        note.hidden = false;
        note.textContent = 'Met al uw voorkeuren vonden we geen exacte match — hieronder tonen we onze mooiste opties die hier het dichtst bij aansluiten.';
      }

      if (result.length === 0) {
        heading.textContent = 'Geen producten gevonden';
        note.hidden = false;
        note.textContent = 'Neem gerust contact op, dan denken we graag persoonlijk met u mee.';
      } else {
        heading.textContent = 'Onze aanbevelingen voor u';
      }

      renderProducts(result);

      if (state.type) {
        moreLink.href = '/collections/' + state.type;
        moreLink.hidden = false;
      }
    });
  }
})();
